//import Contracts from './views/contracts-app';
import AdvancedAnalysis from './views/advanced-analysis';
import Settings from './views/settings-global';
import SiteDetail from './views/site-detail';
import store from "./store";
import { createRouter, createWebHashHistory } from 'vue-router'

import Home from "./views/home-landing";
//import Profile from "./views/profile-page";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

import Realtime from './views/realtime-monitor';
import Dashboard from './views/dashboard-explorer';
import Algorithms from './views/algorithms-monitor'
function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: { 
        requiresAuth: false,
        layout: defaultLayout
      },
      component: Home
    },
   /* {
      path: "/profile",
      name: "profile",
      meta: { 
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },*/

    
    {
      path: "/login-form",
      name: "login-form",
      meta: { 
        requiresAuth: false,
        layout: simpleLayout, 
        title: "Log in to Enfyo App"
      },
      component: loadView("login-form")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: { 
        requiresAuth: false,
        layout: simpleLayout,
        title: "Restore my Account",
        description: "Give us your email address, we will send instructions to recover access to your account"
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }, 
    {
      path: "/dashboard",
      name: "dashboard",
      meta: { 
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Dashboard
    },
    {
      path: "/dashboards/:folderOrDash/:uid",
      name: "dashboardnav",
      meta: { 
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Dashboard
    }, 
    {
      path: "/realtime",
      name: "realtime",
      meta: { 
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Realtime
    },
    {
      path: "/realtime/:uid",
      name: "realtimenav",
      meta: { 
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Realtime
    }
, 
    {
      path: "/site-detail",
      name: "local-site",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: SiteDetail
    }
, 
    {
      path: "/site-detail/:siteId",
      name: "site-detail",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: SiteDetail
    }
, 
    {
      path: "/settings",
      name: "settings",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Settings
    }
, 
    {
      path: "/advanced-analysis",
      name: "advanced-analysis",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AdvancedAnalysis
    }, 
    {
      path: "/algorithms-eod",
      name: "algorithms",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Algorithms
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach( async (to, from, next) => {
  let loggedIn = await store.dispatch('validateLogin')
  
  if (to.name === "login-form" && loggedIn) {
    next({ name: "home" });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
